import { VIEWED_VENDOR_TOUR } from '../types/tour_types';

export const setVendorTourViewed = () => {
    return dispatch => {
        dispatch({
            type: VIEWED_VENDOR_TOUR
        })
    };
};